import React from 'react';
import { media } from '../ui';

export const StyledBanner = ({ section, pageId, settings, site }) => {
  const custom = settings.banners[`${pageId}:${section.id}`];
  const image = custom ? custom.image : section.banner;
  if (!image && !custom) return null;
  return <div className="s-hero-banner" data-testid={`appearance-banner-${section.id}`} data-custom={!!custom} style={custom ? { backgroundColor: custom.color } : undefined}>
    {image && <img data-testid={`public-banner-${section.id}`} src={media(image)} alt="" style={custom ? { objectFit: custom.fit, objectPosition: `${custom.position_x}% ${custom.position_y}%` } : undefined} />}
    {custom && image && <div className="appearance-banner-overlay" data-testid={`banner-overlay-${section.id}`} style={{ backgroundColor: '#000000', opacity: custom.darkening / 100 }} />}
    <img data-testid={`public-hero-logo-${section.id}`} className="s-hero-logo logo-shine" src={media(site.logo)} alt={site.brand} />
  </div>;
};